import {
  Button,
  CloseButton,
  Group,
  Paper,
  TextInput,
  Title,
} from "@mantine/core";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { notifications } from "@mantine/notifications";
import BackButton from "../../../../components/View/BackButton";
import { createUrlShortened } from "../../../../api/ConfigsApi";

const CreateUrlPage = () => {
  const lang = useLanguage((s) => s.language);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    let fd = new FormData(e.target);
    let data = Object.fromEntries(fd);

    setLoading(true);
    createUrlShortened(data?.name, data?.url)
      .then((response) => {
        setTimeout(() => {
          notifications.show({
            message: lang.url_shortener.row_highlight.created,
            color: "tertiary.8",
          });
        }, 300);
        navigate(`../?highlight=${response.data.shortened_url_id}`);
      })
      .finally(() => setLoading(false));
  };
  return (
    <Paper
      p={"lg"}
      w={"40%"}
      mx={"auto"}
      gap={"xs"}
      component={"form"}
      onSubmit={handleSubmit}
    >
      <CloseButton component={Link} to={".."} size={"lg"} mt={-8} mb={8} />
      <Title order={5} mb={16}>
        {lang.url_shortener.create.dialog.title}
      </Title>
      {/* <Title order={5}>{lang.url_shortener.create.dialog.title}</Title> */}
      <TextInput
        name="name"
        label={lang.url_shortener.create.dialog.name}
        placeholder={lang.url_shortener.create.dialog.name}
        autoFocus
        required
        size="md"
        mb={16}
      />

      <TextInput
        name="url"
        type="url"
        label={lang.url_shortener.create.dialog.url}
        placeholder={lang.url_shortener.create.dialog.url}
        required
        size="md"
      />

      <Group justify="flex-end" mt={32}>
        <BackButton />
        <Button type="submit" loading={loading} size="md">
          {lang.url_shortener.create.dialog.submit_button}
        </Button>
      </Group>
    </Paper>
  );
};

export default CreateUrlPage;
